<template>
    <div style="width: 100%;">
        <v-card style="width: 100%;" v-if="aElementos.length==0">
            <v-card-text>
                <v-row class="justify-center text-center">
                    <!-- Icono dentro de un círculo gris -->
                    <v-col cols="12">
                    <div
                        class="d-inline-flex align-center justify-center"
                        style="
                        width: 80px;
                        height: 80px;
                        border-radius: 50%;
                        background-color: #e0e0e0;
                        margin: 0 auto;
                        "
                    >
                        <v-icon
                        large
                        style="font-size: 40px;"
                        >
                        mdi-magnify
                        </v-icon>
                    </div>
                    </v-col>
                    <v-col cols="12" class="text-h6 font-weight-medium  mb-0 pb-0">
                    No se encontraron elementos
                    </v-col>
                    <v-col cols="12" class="text-subtitle-1 grey--text mt-0 pt-0">
                    Intenta con otros criterios de búsqueda
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <div v-else style="width: 100%;" class="pl-4">
            <v-card style="width: 100%;" v-for="oElemento in elementosPaginados" class="my-4">
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="3"><v-img :src="oElemento.aAnexos[0].anexo"></v-img></v-col>
                                <v-col cols="9">
                                    <v-col cols="12" class="py-0 my-0"><span class="black--text">ID:</span> <span class="segundoEstiloTitulo">{{ oElemento.idElemento }}</span></v-col>
                                    <v-col cols="12" class="py-0 my-0"><span class="black--text">Fecha de registro:</span> {{ onMostrarFechaHora(oElemento.FechaRegistro,0) }}</v-col>
                                    <v-col cols="12" class="py-0 my-0"><span class="black--text">Hora de registro:</span> {{ onMostrarFechaHora(oElemento.FechaRegistro,1) }}</v-col>
                                    <v-col cols="12" class="py-0 my-0">
                                        <span class="mr-2"><span class="black--text">Estado:</span></span> 
                                        <v-chip v-if="oElemento?.idEstado=='1'" color="primary" label>En vigilancia</v-chip>
                                        <v-chip v-else-if="oElemento?.idEstado=='2'" color="success" label>Entregado al propietario</v-chip>
                                        <v-chip v-else-if="oElemento?.idEstado=='5'" color="gray" label>En traslado a oficina Av. 68</v-chip>
                                    </v-col>
                                    <v-col cols="12" class="py-0 my-0"><span class="black--text">Observaciones:</span> {{ oElemento.Observaciones }}</v-col>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-divider></v-divider>
                        <v-col cols="12">
                            <v-btn color="primary" block outlined @click="onMostrarElemento(oElemento)">Ver mas detalles</v-btn>
                        </v-col>
            
                    </v-row>
                </v-card-text>
            </v-card>
            <v-row justify="center">
                <v-pagination
                    class="mt-5"
                    v-model="paginaActual"
                    :length="totalPaginas"
                    :total-visible="5"
                    color="primary"
                ></v-pagination>
            </v-row>

        </div>

        <DialogDetalleElemento @onValidacionModalElemento="onValidacionModalElemento"  v-model="oModalDetalleElemento.bModalVisible" :oModalDetalleElemento="oModalDetalleElemento.oModalDetalleElemento"/>
    </div>
</template>
<script>
import DialogDetalleElemento from '@/components/elementosExtraviados/DialogDetalleElemento.vue';

export default {
    name: 'cardElementoExtraviado',
    components:{
        DialogDetalleElemento
    },
    props: {
        oAtributos:{
            type:Object,
            default:()=>{}
        },
        aElementos:{
            type:Array,
            default:()=>[]
        }
    },
    data() {
        return {
            valor: this.value,
            sPlaceholderTemp:"",
            oModalDetalleElemento:{
                bModalVisible:false,
                oModalDetalleElemento:{}
            },
            paginaActual: 1,
            itemsPorPagina: 5,
        }
    },
    watch: {
        valor(NewValor) {
            this.$emit('input', NewValor)
        },
        value(NewValor){
            this.valor = NewValor
        }
    },
    methods : {
        onMostrarFechaHora(sFecha,nPosicion){
            if(sFecha!=""){
            let aFechaTemp = sFecha?.split(" ");
            if(aFechaTemp){
                return aFechaTemp[nPosicion];
            }
            }
            return sFecha;
        },
        onMostrarElemento(oElemento){
            this.oModalDetalleElemento.oModalDetalleElemento = oElemento;
            this.oModalDetalleElemento.bModalVisible = true;
        },
        onValidacionModalElemento(){
            this.oModalDetalleElemento.bModalVisible = false;
        },
    },
    computed: {
        totalPaginas () {
            return Math.ceil(this.aElementos.length / this.itemsPorPagina)
        },

        elementosPaginados () {
            const inicio = (this.paginaActual - 1) * this.itemsPorPagina
            const fin = inicio + this.itemsPorPagina
            return this.aElementos.slice(inicio, fin)
        }
    }
}
</script>
<style scoped>
.segundoEstiloTitulo{
  color: #0056D3;
  font-size: medium;
}
</style>